/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Invite_CopiedInputs */

const en_us2_clubs_invite_copied = /** @type {(inputs: Clubs_Invite_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite copied.`)
};

const pt_br2_clubs_invite_copied = /** @type {(inputs: Clubs_Invite_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convite copiado.`)
};

const es_419_clubs_invite_copied = /** @type {(inputs: Clubs_Invite_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitación copiada.`)
};

const pt_pt2_clubs_invite_copied = /** @type {(inputs: Clubs_Invite_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convite copiado.`)
};

const fr_fr2_clubs_invite_copied = /** @type {(inputs: Clubs_Invite_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitation copiée.`)
};

const de_de2_clubs_invite_copied = /** @type {(inputs: Clubs_Invite_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladung kopiert.`)
};

const it_it2_clubs_invite_copied = /** @type {(inputs: Clubs_Invite_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invito copiato.`)
};

/**
* | output |
* | --- |
* | "Invite copied." |
*
* @param {Clubs_Invite_CopiedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_invite_copied = /** @type {((inputs?: Clubs_Invite_CopiedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Invite_CopiedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_invite_copied(inputs)
	if (locale === "es-419") return es_419_clubs_invite_copied(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_invite_copied(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_invite_copied(inputs)
	if (locale === "de-DE") return de_de2_clubs_invite_copied(inputs)
	if (locale === "it-IT") return it_it2_clubs_invite_copied(inputs)
	return en_us2_clubs_invite_copied(inputs)
});
export { clubs_invite_copied as "clubs.invite_copied" }